import React, { FC, ReactElement, useState } from 'react';
import { Layout } from 'tea-component';
import LeftMenu from '@/pages/home/components/LeftMenu';
import MainMenu, { HeaderMenu } from '../../pages/Agent/components/HeaderMenu';
import MemoryPreferences from '../../pages/Agent/components/HeaderMenu/components/MemoryPreferences';
import MemoryEntry from '../../pages/Agent/components/HeaderMenu/components/MemoryEntry';
import TokenUsageQuota from '../../pages/Agent/components/TokenUsageQuota';
import { useSelector, shallowEqual } from 'umi';
import { storage } from '@/utils/utils';
import { SearchSessionQueryResponse } from '@/pages/aigc/pages/Agent/service/service';
import './index.scss';

const { Body, Content } = Layout;

interface IProps {
  children?: React.ReactNode;
  [key: string]: unknown;
}

const AgentLayout: FC<IProps> = ({ children }): ReactElement => {
  // 调整动机：目前Context的只是用于传递chatList等数据，其他value暂时没用上，就先注释了，后续有需要再打开，为保证之前的数据能够全局共享
  // 在useChatList这个接口加了一个catchKey，这将导致全局共享chatList数据，效果等于Context, 调用方式从Context改为hook
  // 另外一个目的也是兼容Copilot, Provider目前只作用于Agent模块,下层组件会用到chatList做一些处理(如分享 左侧菜单) Copilot使用不到这边的fetchChatList, 会导致异常, chatList这里不做外部传入,直接全局使用
  // const { chatList, loading, fetchChatList } = useChatList();
  const value = storage.getItem('__dba_show_left_menu');
  const [initialTransitionDisabled, setInitialTransitionDisabled] = useState(
    value === null ? true : value === 'hidden',
  );
  const [searchChatData, setSearchChatData] =
    useState<SearchSessionQueryResponse['chats']>();
  const [showNoDataInReturn, setShowNoDataInReturn] = useState(false);
  const [showMemoryPreferences, setShowMemoryPreferences] = useState(false);

  const userInfo = useSelector(
    (state: any) => state?.home?.userInfo,
    shallowEqual,
  );

  return (
    // <ChatContext.Provider value={{ chatList, loading, fetchChatList }}>
    <Body
      className="dba-agent-layout-body"
      data-initial-disable-left-menu-transition={initialTransitionDisabled}
    >
      {showMemoryPreferences && (
        <MemoryPreferences onClose={() => setShowMemoryPreferences(false)} />
      )}
      {userInfo && (
        <>
          <LeftMenu
            title="Agent"
            menuList={[]}
            customHeaderElement={
              <HeaderMenu
                setInitialTransitionDisabled={setInitialTransitionDisabled}
                setSearchChatData={setSearchChatData}
                showNoDataInReturn={showNoDataInReturn}
                setShowNoDataInReturn={setShowNoDataInReturn}
              />
            }
            customFooter={
              <div className="dba-agent-layout__footer">
                <TokenUsageQuota />
                <MemoryEntry onOpen={() => setShowMemoryPreferences(true)} />
              </div>
            }
          >
            <MainMenu
              showNoDataInReturn={showNoDataInReturn}
              searchChatData={searchChatData}
            />
          </LeftMenu>

          <Content>{children}</Content>
        </>
      )}
    </Body>
    // </ChatContext.Provider>
  );
};
export default AgentLayout;
